import axios from 'axios';
import { ref } from 'vue';
import notify from '@/store/Common/notify';

function getSettingArray(settings, name) {
    const settingGroup = settings?.find(setting => setting.settingName === name);
    return settingGroup?.settingArray;
}

export function useSettingForm() {
    const loading = ref(false);
    const settings = ref({});

    function save(page, settingName, settings) {
        loading.value = true;
        axios.post(`/api/settings/page/${page}`, {
            settings: {
                settingArray: settings,
                settingName: settingName
            }
        })
            .then((response) => {
                notify(response.data.message, 'success');
            })
            .finally(() => {
                loading.value = false;
            });
    }

    function getData(page, settingName) {
        loading.value = true;

        axios.get(`/api/settings/page/${page}`)
            .then(response => {
                const responseData = getSettingArray(response.data.settings, settingName);

                if (!responseData) {
                    loading.value = false;
                    return;
                }

                settings.value = { ...responseData };

                loading.value = false;
            });
    }

    return {
        loading,
        settings,
        getData,
        save
    };
}